import { scenePortraits } from '../content-adapter'
import type { CSSProperties } from 'react'

type SceneBackdropProps = {
  src: string
  background: string
}

export function SceneBackdrop({ src, background }: SceneBackdropProps) {
  return (
    <div className="scene-backdrop" aria-hidden="true" style={{ '--scene-background': background, '--scene-art': src ? `url(${JSON.stringify(src)})` : 'none', '--scene-art-portrait': src ? `url(${JSON.stringify(scenePortraits[src] || src)})` : 'none' } as CSSProperties} />
  )
}
